import { X } from 'react-feather';

import { cn } from '@/shared/utils/cn';
import { ModalProps } from '@/shared/types/CommonTypes';

const sizeClasses = {
  sm: 'w-[422px]',
  md: 'w-[480px]',
  lg: 'w-[640px]',
} as const;

const Modal = ({
  isOpen,
  onClose,
  children,
  title,
  size = 'md',
  className,
  titleAlign = 'left',
}: ModalProps) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[999] flex h-screen w-screen items-center justify-center bg-black/60">
      <div
        className={cn(
          'relative z-50 mx-auto rounded-2xl bg-white p-6',
          titleAlign === 'center' ? 'text-center' : 'text-left',
          sizeClasses[size],
          className,
        )}
      >
        <button
          className="absolute right-5 top-5 h-5 w-5 cursor-pointer bg-transparent"
          type="button"
          onClick={onClose}
          aria-label="Close modal"
        >
          <X size={24} color="#999" strokeWidth={2} />
        </button>

        {title && (
          <p
            className={cn(
              'mb-5 text-[20px] font-semibold text-[#95699f]',
              titleAlign === 'center' ? 'text-center' : 'text-left',
            )}
          >
            {title}
          </p>
        )}

        <div className="mt-2">{children}</div>
      </div>
    </div>
  );
};

export default Modal;
